var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    width: '200px'
  })},[_c('PictureFrame',{attrs:{"src":_vm.src,"clicked":_vm.clicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }